import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import {
  postNotBoardedTicketReport,
  clearErrorPostingNotBoardedTicketReport,
} from '../../../../actions';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import NotBoardedTicketReportForm from '../not-boarded-ticket-report/NotBoardedTicketReportForm';
import {
  NEW_NOT_BOARDED_TICKET_REPORT_PATH,
  NOT_BOARDED_TICKET_REPORTS_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { tzNormalizeDate } from '../../../../utils/date';

class NewNotBoardedTicketReport extends Component {
  componentWillUnmount() {
    this.props.clearErrorPostingNotBoardedTicketReport();
  }
  render() {
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={this.props.breadcrumbs} />
        <Row>
          <Col>
            <h1 id="title">Nuevo Reporte de Boletos No Abordados</h1>
            <p id="text">Crear un nuevo reporte de boletos no abordados.</p>
          </Col>
        </Row>
        <NotBoardedTicketReportForm
          onSubmit={this.props.postNotBoardedTicketReport}
          initialValues={{
            fromDate: tzNormalizeDate(),
            toDate: tzNormalizeDate(),
            force: false,
          }}
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ ReportUnit }) => ({
  breadcrumbs: [
    ...ReportUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Boletos No Abordados',
      href: NOT_BOARDED_TICKET_REPORTS_PATH,
    },
    {
      text: 'Crear',
      href: NEW_NOT_BOARDED_TICKET_REPORT_PATH,
    },
  ],
});

const mapDispatchToProps = {
  postNotBoardedTicketReport,
  clearErrorPostingNotBoardedTicketReport,
};

NewNotBoardedTicketReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  postNotBoardedTicketReport: PropTypes.func.isRequired,
  clearErrorPostingNotBoardedTicketReport: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewNotBoardedTicketReport);
